export default "__VITE_ASSET__4a23cda5__"